import { render, staticRenderFns } from "./TSwitch.vue?vue&type=template&id=697caa3f&scoped=true&"
import script from "./TSwitch.vue?vue&type=script&lang=js&"
export * from "./TSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TSwitch.vue?vue&type=style&index=0&id=697caa3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697caa3f",
  null
  
)

/* custom blocks */
import block0 from "./TSwitch.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports